export default function SectionHeading({ overline, title, lede, align = "left", testId, light = false }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`} data-testid={testId}>
      {overline && (
        <div className={`overline mb-4 ${light ? "text-ochre" : "text-terracotta"}`}>{overline}</div>
      )}
      <h2 className={`editorial-h2 ${light ? "text-linen" : "text-ink"}`}>{title}</h2>
      {lede && (
        <p className={`mt-6 text-base leading-relaxed ${light ? "text-linen/70" : "text-muted2"} max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
          {lede}
        </p>
      )}
    </div>
  );
}
